import React from "react"
import classes from "./ResultSet.module.css"
import { useTranslation } from "react-i18next"

const fieldnames = ["Idx", "Result"]
const ResultSet = props => {
    const { t } = useTranslation()

    const headlines = [t("translation:LayoutMsg.Coop_ResultDetail_00.T_Rank_00"), t("misc:SeedListing.Result")]
    const header = headlines.map((v, idx) => (
        <th key={idx} className={classes.TableHead}>
            {v}
        </th>
    ))
    let body = (
        <tr className={classes.ContentNotFound}>
            <td colSpan={headlines.length}>{t("misc:Checker.ResultNoResults")}</td>
        </tr>
    )
    if (props.results.length > 0) {
        body = props.results.map((entry, idx) => {
            return (
                <tr key={idx} className={(idx & 1) === 0 ? classes.TDEven : classes.TDOdd}>
                    {fieldnames.map((v, i) => {
                        return <td key={idx + "." + i}>{entry[v]}</td>
                    })}
                </tr>
            )
        })
    }
    return (
        <div className={classes.Wrapper}>
            <table className={classes.Table}>
                <thead>
                    <tr>{header}</tr>
                </thead>
                <tbody>{body}</tbody>
            </table>
        </div>
    )
}

export default React.memo(ResultSet)
